<template>
	<div class="notice_popup view">
		<div class="close">
			<img src="/images/close.png" alt="닫기" @click="$emit('close')"/>
		</div>
		<div class="view-tit">{{projectNm}}</div>
		<div class="sub-tit">인터뷰 완료 IT프로</div>
		<div class="listArea">
			<div class="Board type3">
				<table class="Board_type3 admin other">
					<colgroup>   <!-- 3, 3, 5, 7, 3, 3, 6, 6, 14, 10, 15, 22 -->
						<col width="3%">
						<col width="7%">
						<col width="7%">
						<col width="4%">
						<col width="4%">
						<col width="7%">
						<col width="7%">
						<col width="7%">
						<col width="14%">
						<col width="9%">
						<col width="16%">
						<col width="15%">
					</colgroup>
					<thead>
						<tr>
							<th>NO</th>
							<th>평균<br/>평가등급</th>
							<th>성명</th>
							<th>성별</th>
							<th>연생</th>
							<th>기술등급<br/>(학력기준)</th>
							<th>기술등급<br/>(자격기준)</th>
							<th>투입등급</th>
							<th>소속사</th>
							<th>담당분야</th>
							<th>참여기간</th>
							<th>인터뷰상태</th>
						</tr>
					</thead>
					<tbody>
						<template v-if="projectTecMberList.length > 0">
							<tr v-for="(mberRow, mberIdx) in projectTecMberList" :key="mberIdx">
								<td class="score">{{mberRow.rn}}</td>
								<td class="score"><gradeImg type="TOT_EVAL_ADM" :grade="mberRow.totEvalGradeCd" :specialYn="mberRow.specialGradeYn"/></td>
								<td class="score name">{{mberRow.mberNm}}</td>
								<td class="score">{{mberRow.gender | gender}}</td>
								<td class="score">{{mberRow.birthYyyymmdd | birthYear}}</td>
								<td class="score"><gradeImg type="SCHOOL_TECH_ADM" :grade="mberRow.resumeSchoolTechGradeCd"/></td>
								<td class="score"><gradeImg type="LICENSE_TECH_ADM" :grade="mberRow.resumeLicenseTechGradeCd"/></td>
								<td class="score"><gradeImg type="LICENSE_TECH_ADM" :grade="mberRow.projectJoinTechGradeCd"/></td>
								<td :class="mberRow.corpSeq != undefined? 'score':'score color-gray'">{{mberRow.corpNm}}</td>
								<td class="score">{{mberRow.workCont}}</td>
								<td class="score">{{mberRow.joinStartYyyymmdd | date('yyyy.MM.dd')}} - {{mberRow.joinEndYyyymmdd | date('yyyy.MM.dd')}}</td>
								<td class="score">
									<gradeImg type="INTERVIEW_RES_ADM" :grade="mberRow.intvImg" v-if="mberRow.intvImg" 
										:style="mberRow.intvImg == '04' ? 'cursor: pointer;' : ''"
										@click="intvPup(mberRow)" />
									<p v-if="!mberRow.intvImg">인터뷰 없음</p>
									<!-- <p v-if="'03,04'.indexOf(mberRow.statusImg) > -1 && mberRow.interviewYmd">{{mberRow.interviewYmd | date('yyyy.MM.dd')}} / {{mberRow.interviewAmPm}} {{mberRow.interviewHour}}</p> -->
								</td>
							</tr>
						</template>
						<template v-else>
							<tr>
								<td class="score" colspan="13" style="font-weight: bold; font-size: x-large;">인터뷰 인원이 없습니다.</td>
							</tr>
						</template>
					</tbody>
				</table>
				<!-- 20230502 테스트 : 선택한 IT프로 이력부분 다운 -->
				<!-- <div class="test-out" style="background-color:red; height:50px; margin-left:80px;">
					<div class="test-in" style="background-color:blue; height:50px; margin:0 auto; width:300px;"></div>
				</div> -->
			</div>
		</div>
	</div>
</template>

<script>
import gradeImg from "@/components/highpro/GradeImg.vue";

export default {
	components: { gradeImg },
	props: { param:Object },
	data() {
		return {
			mberInfo : {},
			projectNm: this.param.projectNm,
			projectSeq: this.param.projectSeq,
			projectTecMberList:[],
			projectSeqTecMber:'',
		}
	},

	mounted() {
		this.getTecMberList()
	},

	methods : {
		getTecMberList() {
			var input = {
				projectSeq : this.projectSeq,
				actualInterviewYn: 'Y'
			};

			this.$.httpPost('/api/prj/adm/getRecruitProjectTecMberList', input)
				.then(res => {
					// console.log('getRecruitProjectTecMberList', res.data);
					this.projectTecMberList	= res.data.projectTecMberList;
					this.projectSeqTecMber = this.projectSeq;

				}).catch(this.$.httpErrorCommon);
		},
	}
}
</script>